import { useCallback, useEffect, useRef } from 'react';

import type { DQLEditorValidityInfo } from './DQLEditor.js';

/**
 * @internal
 */
export const useValidationCallbacks = (
  onValidationStart?: () => void,
  onValidationEnd?: (validityInfo: DQLEditorValidityInfo[]) => void,
): [() => void, (validityInfo: DQLEditorValidityInfo[]) => void] => {
  const onValidationStartRef = useRef(onValidationStart);
  const onValidationEndRef = useRef(onValidationEnd);

  useEffect(() => {
    onValidationStartRef.current = onValidationStart;
  }, [onValidationStart]);

  useEffect(() => {
    onValidationEndRef.current = onValidationEnd;
  }, [onValidationEnd]);

  const fireValidationStart = useCallback(() => {
    onValidationStartRef.current?.();
  }, []);

  const fireValidationEnd = useCallback(
    (validityInfo: DQLEditorValidityInfo[]) => {
      onValidationEndRef.current?.(validityInfo);
    },
    [],
  );

  return [fireValidationStart, fireValidationEnd];
};
